module.exports = __webpack_public_path__ + "static/media/engine-icon-warn.9fec4ce4.png";